'use client';

const SvgChat = () => <div className="cx-help-chat h-6 w-6"></div>;

const ProductDetailsChat = () => {
  function openChat() {
    const widgetFrame = document?.querySelector('iframe[src*="kodif"]');
    if (widgetFrame && widgetFrame?.contentWindow) {
      widgetFrame.contentWindow.postMessage(
        { type: 'toggle-expanded', isExpanded: true },
        '*'
      );
    }
  }

  return (
    <button
      className={`bg-parlor-green-95 hover:bg-parlor-green-80 flex h-10 w-full items-center justify-center transition duration-400`}
      onClick={openChat}
    >
      <SvgChat />
      <p className="pl-2">Chat</p>
    </button>
  );
};

export default ProductDetailsChat;
